import tinycolor from 'tinycolor2';

export function isDarkColor(color: string) {
  return tinycolor(color).isDark();
}
